import React from 'react';
import type { ReactNode } from 'react';

import { ThemeProvider } from './ThemeProvider';
import { PackageProviders } from './PackageProviders';
import type { ThemeProviderProps } from './ThemeProvider';

type ReckonBalanceCoreProps = {
  themeMode: ThemeProviderProps['mode'];
  children?: ReactNode;
} & Pick<ThemeProviderProps, 'linkComponent' | 'themeOverrides'>;

export const ReckonBalanceCore = ({
  themeMode,
  themeOverrides,
  linkComponent,
  children,
}: ReckonBalanceCoreProps) => {
  return (
    <ThemeProvider
      mode={themeMode}
      linkComponent={linkComponent}
      themeOverrides={themeOverrides}
    >
      <PackageProviders>{children}</PackageProviders>
    </ThemeProvider>
  );
};
